import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var ymPushEvent = function ymPushEvent() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 26001372;
  if (window.ym) {
    if (payload) {
      window.ym(id, 'reachGoal', key, payload);
    }
    window.ym(id, 'reachGoal', key);
  }
};
export var ymPushParams = function ymPushParams() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 26001372;
  if (window.ym) {
    window.ym(id, 'params', payload);
  }
};
export var handleSendAnalytics = function handleSendAnalytics(payload) {
  if (typeof window !== 'undefined') {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    window.dataLayer.push(_objectSpread({}, payload));
  }
};